var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2928 18.707C9.10532 18.5193 9 18.2647 9 17.9993C9 17.7339 9.10532 17.4794 9.2928 17.2917L14.5861 11.994L9.2928 6.69623C9.11063 6.50746 9.00983 6.25463 9.01211 5.9922C9.01439 5.72977 9.11957 5.47873 9.30498 5.29316C9.4904 5.10758 9.74123 5.00232 10.0034 5.00004C10.2656 4.99776 10.5183 5.09864 10.7069 5.28096L16.7072 11.2863C16.8947 11.474 17 11.7286 17 11.994C17 12.2594 16.8947 12.5139 16.7072 12.7016L10.7069 18.707C10.5193 18.8946 10.265 19 9.99984 19C9.73466 19 9.48034 18.8946 9.2928 18.707Z",
    fill: "#FFB829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRight);
export default __webpack_public_path__ + "static/media/icon_right.d4beae0a08017bc44d22ccf0317eb49c.svg";
export { ForwardRef as ReactComponent };